export default __webpack_public_path__ + "static/media/steering-knuckle.32ba8466.png";